function iconFlick() {
    iconGroup.forEach(arr => {
        const icons = arr.querySelectorAll(".js-icon");
        let len = icons.length;
        let idx = 0;
        const showNext = function () {
            const entry = icons[idx];
            if (idx < len) {
                idx++;
                entry.classList.add('is-active');
                setTimeout(function(){
                    entry.classList.remove('is-active');
                }, 200);
            } else {
                idx = 0;
            }
            setTimeout(showNext, 200);
        }
        showNext();
    })
}
